import { Button, Dialog } from "@repo/ui";
import { CheckCircle, Loader2, Mail, XCircle } from "lucide-react";

type EmailStatus = "idle" | "sending" | "success" | "error";

// --- Dialogue d'envoi des résultats ---

interface SendResultsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  status: EmailStatus;
  message: string;
  evaluationTitles: string[];
  emailCandidat?: string;
  onSend: () => void;
}

export function SendResultsDialog({
  isOpen,
  onClose,
  status,
  message,
  evaluationTitles,
  emailCandidat,
  onSend,
}: SendResultsDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Envoyer les résultats"
      className="max-w-md"
    >
      <div className="space-y-4">
        {status === "idle" && (
          <p className="text-sm text-muted-foreground">
            Les résultats de{" "}
            <strong>
              {evaluationTitles.reduce<React.ReactNode[]>(
                (acc, title, i, arr) => {
                  if (i === 0) return [title];
                  if (i === arr.length - 1) return [...acc, " et ", title];
                  return [...acc, ", ", title];
                },
                [],
              )}
            </strong>{" "}
            seront envoyés à <strong>{emailCandidat}</strong>.
          </p>
        )}
        {status === "sending" && (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2">{message}</span>
          </div>
        )}
        {status === "success" && (
          <div className="flex flex-col items-center justify-center py-8">
            <CheckCircle className="h-12 w-12 text-etat-fait" />
            <p className="mt-4 text-center text-sm text-muted-foreground">
              {message}
            </p>
          </div>
        )}
        {status === "error" && (
          <div className="flex flex-col items-center justify-center py-8">
            <XCircle className="h-12 w-12 text-etat-erreur" />
            <p className="mt-4 text-center text-sm text-muted-foreground">
              {message}
            </p>
          </div>
        )}
        <div className="flex justify-end gap-2 pt-4">
          {status === "idle" && (
            <>
              <Button variant="outline" onClick={onClose}>
                Annuler
              </Button>
              <Button onClick={onSend}>
                <Mail className="h-4 w-4 mr-2" />
                Envoyer
              </Button>
            </>
          )}
          {(status === "success" || status === "error") && (
            <Button onClick={onClose}>Fermer</Button>
          )}
        </div>
      </div>
    </Dialog>
  );
}
